import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const GetSearchBrands = (params: any) =>
    request({
        url: ApiURL.Query.GetSearchBrands + '?' + params,
        method: RequestType.GET,
    });

const SellerPortalProductQuery = {
    GetSearchBrands,
};

export default SellerPortalProductQuery;